import Swiper from "swiper/bundle";

function initializeSwiper(selector, navigationClass) {
  return new Swiper(selector, {
    direction: "horizontal",
    loop: false,
    centeredSlides: false,
    spaceBetween: 24,
    navigation: {
      nextEl: `.swiper-button-next.menu-navigation.${navigationClass}`,
      prevEl: `.swiper-button-prev.menu-navigation.${navigationClass}`,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      425: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3.2,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });
}

// Check if window width is greater than or equal to 992 pixels
if (window.innerWidth >= 992) {
  const menuFacades = initializeSwiper(".menu-slider.facades", "facades");
  const menuSolutions = initializeSwiper(".menu-slider.solutions", "solutions");
  const menuInspiration = initializeSwiper(".menu-slider.inspirations", "inspirations");
}
